import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import SupportQuestionViewDialog from '../support_question_view';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';
import EmptyState, { EmptyStateActions } from '../../components/EmptyState';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { SolidButton } from '../../components/Button';

export default function Launcher(props) {
  const config = useDialogConfig();

  const supportQuestion = useConnect('supportQuestion.byId', {
    id: config.params.supportQuestionId
  });

  if (supportQuestion.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (
    supportQuestion.state === PayloadStates.NOT_FOUND ||
    supportQuestion.state === PayloadStates.ERROR_FETCHING
  ) {
    return (
      <DialogTemplate className="w-screen max-w-screen-md" overflow={false}>
        <CloseDialogButton onCancel={props.onClose} />
        <EmptyState
          border={false}
          icon={ExclamationTriangleIcon}
          title="Support question does not exist."
        >
          <EmptyStateActions>
            <SolidButton
              // label="Explore other opportunities"
              label="Close"
              onClick={props.onClose}
            />
          </EmptyStateActions>
        </EmptyState>
      </DialogTemplate>
    );
  }

  return (
    <SupportQuestionViewDialog
      supportQuestion={supportQuestion}
      onCancel={props.onClose}
    />
  );
};
